import JSZip from "jszip";
import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import EmployeeContract from "./../../Pdfs/EmployeeContract";
import AbsenteeismPdf from "./../../Pdfs/AbsenteeismPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

export default function DownloadPDFPopup({
  popupState,
  setPopupState,
  selectedRowsData = [],
  company,
}) {
  console.log(selectedRowsData,company, "selected rows data......print.....");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [percentage, setPercentage] = useState(1);

  const totalRows = selectedRowsData.length;

  const downloadHandler = async () => {
    const completedRows = [];

    return new Promise((resolve, reject) => {
      const zip = new JSZip();
      for (let rowData of selectedRowsData) {
        console.log(rowData, "id of row");
        zip.file(
          `${rowData?.candidate_id}_Employment_Contract.pdf`,
          pdf(<EmployeeContract data={rowData} company={company} />).toBlob()
        );
        zip.file(
          `${rowData?.candidate_id}_Absenteeism.pdf`,
          pdf(<AbsenteeismPdf data={rowData} company={company} />).toBlob()
        );

        completedRows.push(rowData?.id);
        const currentPercentage =
          ((totalRows - completedRows.length) / totalRows) * 100;
        setPercentage(currentPercentage == 0 ? 1 : currentPercentage);
      }

      zip
        .generateAsync({ type: "blob" })
        .then((blob) => {
          if (completedRows.length == totalRows) {
            resolve(true);
            saveAs(blob, "Candidate List PDF.zip");
          }
        })
        .catch((error) => {
          reject(false);
        });
    });
  };

  useEffect(() => {
    setLoading(true);

    downloadHandler()
      .then((data) => {
        console.log(data, "data");
        setLoading(false);
        setPopupState({ open: false });
      })
      .catch((error) => {
        setLoading(false);
        setPopupState({ open: false });
        console.log(error, "error");
      });
  }, []);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          popupState.open ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-xl w-full h-auto min-h-[10rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col gap-10 justify-between p-4 relative ">
          <div className="flex justify-between items-start w-full">
            <div>
              <h1 className="text-xl font-semibold">PDF Download</h1>
            </div>
            <button
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopupState((p) => ({ open: false }));
              }}
              disabled={loading}
            >
              <IoMdClose size={"1.2rem"} />
            </button>
          </div>
          <div className="w-full max-w-md mx-auto">
            <div className="w-full flex justify-between">
              <h2>Downloading Files</h2>
              <h2>{Math.floor(percentage)}%</h2>
            </div>
            <progress className="progress w-full"></progress>
          </div>
        </div>
      </div>
    </>
  );
}
